<template>
    <ModalFormCard class="modal-default" headerCSS='!h-0 !overflow-hidden'>
        <template #default="{ saving, errors }">
            <h1 class='text-28 font-bold'>Error loading page</h1>

            <p class='text-15 mt-7 whitespace-pre-wrap'>{{ error.message }}</p>
            <p class='text-13 mt-4'>{{ traceLast.file.replace("/Users/jameswaring/sites", "") }}</p>
            <p class='text-13'>Line {{ traceLast.line }}</p>

            <button class='button-black h-10 px-6 mt-6' @click='reload'>Reload page</button>
            <a class='button-purple h-10 px-6' :href="'cursor://file/'+traceLast.file+':'+traceLast.line">Open cursor</a>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    data() {

    },

    methods: {
        reload() {
            this.editingModel.call().load()
            this.$event.$emit('modal-close');
        }
    },

    computed: {
        error() {
            return this.editingModel.pageLoadError
        }, 
        
        traceLast() {
            if (this.error?.trace == null) {
                return null
            }

            return this.error.trace.find((t) => {
                return t.file && t.file.indexOf("vendor") == -1
            })
        }
    },
}
</script>
